/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenMonitorOffIcon16Solid = forwardRef('TechScreenMonitorOffIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.519.281A.875.875 0 0 0 1.28 1.52l.93.929A2.698 2.698 0 0 0 1 4.7v4.6A2.7 2.7 0 0 0 3.7 12H6v1H5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-1v-1h1.763l2.118 2.119a.875.875 0 1 0 1.238-1.238L2.519.281Z" }),
        React.createElement("path", { d: "M15 9.3c0 .39-.083.761-.232 1.097L6.371 2H12.3A2.7 2.7 0 0 1 15 4.7v4.6Z" })));
});
